import React from "react";
import { Box } from "@mui/material";

import "../stylesheets/components/_Divider.scss";

const Divider: React.FC = () => {
  return <Box component={"div"} className="background-bar" />;
};

export default Divider;
